// @ts-strict-ignore
import { FormError } from '@/hybrid/core/FormError.atom';
import React, { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { TextButton } from '@/hybrid/core/TextButton.atom';

type SelectOption = {
  value: string;
  label: string;
};

export type SelectAndAddProps = {
  selectedItemIds: string[];
  options: SelectOption[];
  selectedValue: SelectOption;
  onChange: (value: SelectOption) => void;
  onAddClick: () => void;
  isAssetAndItemSelected?: boolean;
  isSelectAllDisabled?: boolean;
};

/**
 * Contains dropdown and add button for multi-select.
 *
 * Manages loading state for add button
 */
export const SelectAndAdd: React.FunctionComponent<SelectAndAddProps> = ({
  selectedItemIds,
  options,
  selectedValue,
  onChange,
  onAddClick,
  isAssetAndItemSelected,
  isSelectAllDisabled,
}) => {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  const renderResult = () => {
    if (isAssetAndItemSelected) {
      return <FormError errorText="MULTI_SELECT.ASSET_GROUP.ERROR" />;
    }

    if (selectedItemIds.length > 0) {
      return (
        <div className="flexColumnContainer flexAlignCenter">
          <Select
            id="selectActionsOptions"
            classNamePrefix="react-select-small"
            className="flexFillOverflow mr10"
            value={selectedValue}
            options={options}
            onChange={onChange}
            isSearchable={false}
            isClearable={false}
          />
          <TextButton
            testId="addItems"
            variant="theme"
            extraClassNames="sq-btn-xs"
            disabled={isLoading}
            label="ADD"
            icon={isLoading ? 'fa-spinner fa-spin' : undefined}
            iconStyle={isLoading ? 'white' : undefined}
            onClick={() => {
              setLoading(true);
              onAddClick();
            }}
          />
        </div>
      );
    }

    if (isLoading) {
      setLoading(false);
    }

    return <span className={classNames({ disabledLook: isSelectAllDisabled })}>{t('SELECT_ALL')}</span>;
  };

  return (
    <div data-testid="selectAndAdd" className="ml5 width-maximum">
      {renderResult()}
    </div>
  );
};
